var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file MultiSelect组件
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';
import { classPrefix, EleResize } from '../../common/util';

import Search from '../Search';
import MultiSelectInputItem from '../TreeSelect/MultiTreeSelect/MultiSelectInputItem';
import SelectPanelItem from '../Select/SelectPanelItem';

import PopperWrap from '../PopperWrap';

import './MultiSelect.less';
/* global getComputedStyle */

/**
 * 参数说明
 * optionData           必需，下拉框需要的数据项
 * className            可选，自定义class
 * increment            可选，form专用，必需
 * classPrefix          可选，自定义class前缀
 * placeHolder          可选，placeholder
 * onHandleChange       可选，数据回调(form用)
 * getValue             可选，数据回调
 * validate             可选，form专用，必需
 * width                可选，自定义宽度
 * height               可选，自定义高度
 * label                可选，左边的说明文字
 * value                可选，多选的值
 * noWarning            可选，不要提示
 * disabled             可选，不可用态
 * tips                 可选，右边的说明文字
 * showSearch           可选，有搜索功能
 * cancelIcon           可选，清空选项的icon是否显示
 * preventOverflowEnabled     非必需,下拉是否受overflow碰撞影响
 * popupOnBody          可选,下拉是否挂在body上
 */

var MultiSelect = function (_Component) {
    _inherits(MultiSelect, _Component);

    function MultiSelect(props) {
        _classCallCheck(this, MultiSelect);

        var _this = _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).call(this, props));

        _initialiseProps.call(_this);

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;
        var value = props.value,
            optionData = props.optionData;

        _this.state = {
            optionData: optionData,
            isShowPanel: false,
            iconOnHover: false,
            inputFocus: false,
            searchValue: '',
            inputWidth: 400
        };
        _this.formCallback(value, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(MultiSelect, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.value, this.props.value)) {
                this.formCallback(np.value, this.FORM_NEED_VALIDATE);
                this.PopperWrap.update(); // 更新下拉位置
            }
            var optionData = np.optionData;
            if (this.state.searchValue) {
                optionData = this.filterOptionData(this.state.searchValue, optionData);
            }
            this.setState({ optionData: optionData });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.responsive) {
                return;
            }
            this.resizeHandler();
            EleResize.on(this.tsContainer, this.resizeHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);

            if (!this.props.responsive) {
                return;
            }
            EleResize.off(this.tsContainer, this.resizeHandler);
        }
    }, {
        key: 'formCallback',
        value: function formCallback(data, type, isDelete) {
            var _props = this.props,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange;


            if (onHandleChange && _.isFunction(onHandleChange)) {
                onHandleChange({
                    name: name,
                    value: data
                }, this, type, increment, isDelete);
            }
        }
    }, {
        key: 'isInValue',
        value: function isInValue(item) {
            var value = this.props.value;
            return value.some(function (i) {
                return i.id === item.id;
            });
        }
    }, {
        key: 'searchInputFocus',
        value: function searchInputFocus() {
            var searchInput = this.searchWrapper.querySelector('input');
            searchInput.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this,
                _classnames2;

            var _props2 = this.props,
                className = _props2.className,
                classPrefix = _props2.classPrefix,
                width = _props2.width,
                disabled = _props2.disabled,
                cancelIcon = _props2.cancelIcon,
                showSearch = _props2.showSearch,
                label = _props2.label,
                tips = _props2.tips,
                noWarning = _props2.noWarning,
                validate = _props2.validate,
                zIndex = _props2.zIndex,
                preventOverflowEnabled = _props2.preventOverflowEnabled,
                popupOnBody = _props2.popupOnBody,
                responsive = _props2.responsive,
                searchClear = _props2.searchClear;

            var rootCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-multi-select-wrap', true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, 'margin-bottom-24', !noWarning), _defineProperty(_classnames, 'responsive', responsive), _classnames));

            var realWidth = responsive ? this.state.inputWidth : width;

            var inputCls = classnames({
                'multi-select-input': true
            });
            var hasWarning = -1;
            var containerCls = classnames({
                'input-container': true,
                'multi-select-diabled': disabled,
                'multi-select-focus': this.state.isShowPanel || this.state.inputFocus,
                'warning-border': !noWarning && validate && validate.ret === hasWarning
            });
            var containerStyle = {
                width: responsive ? '100%' : parseFloat(width)
            };
            var hasCancelIcon = cancelIcon && this.state.iconOnHover && this.props.value.length !== 0;
            var iconCls = classnames({
                'multi-select-icon': true,
                'multi-select-icon-active': !hasCancelIcon && this.state.isShowPanel,
                'multi-select-cancel-icon': hasCancelIcon
            });
            var leftAndRightPadding = 20;
            var searchHight = 32;
            var searchProps = {
                value: this.state.searchValue,
                name: 'multiSelectSearch',
                placeHolder: '请输入搜索内容',
                noDistance: true,
                height: searchHight,
                width: parseFloat(realWidth) - leftAndRightPadding,
                getValue: this.searchChange,
                cancelIcon: searchClear
            };
            return React.createElement(
                'div',
                { className: rootCls },
                label && React.createElement(
                    'div',
                    { className: [classPrefix + '-form-label'] },
                    label
                ),
                React.createElement(PopperWrap, {
                    ref: function ref(el) {
                        _this2.PopperWrap = el;
                    },
                    containerNode: React.createElement(
                        'div',
                        {
                            className: containerCls,
                            ref: function ref(el) {
                                _this2.tsContainer = el;
                            },
                            style: containerStyle
                        },
                        React.createElement(
                            'ul',
                            { className: inputCls, tabIndex: '-1', onClick: this.inputOnClick },
                            this.renderMultiItems()
                        ),
                        React.createElement('div', {
                            className: iconCls,
                            onClick: this.iconOnClick,
                            onMouseEnter: this.iconOnHover,
                            onMouseLeave: this.iconOnHover
                        }),
                        !noWarning && React.createElement(
                            'div',
                            { className: classPrefix + '-form-warning' },
                            validate && validate.message ? React.createElement(
                                'div',
                                null,
                                React.createElement('i', { className: classPrefix + '-form-error' }),
                                validate.message
                            ) : ''
                        )
                    ),
                    popupNode: React.createElement(
                        'div',
                        null,
                        showSearch && React.createElement(
                            'div',
                            {
                                className: 'multi-select-search',
                                ref: function ref(el) {
                                    _this2.searchWrapper = el;
                                }
                            },
                            React.createElement(Search, searchProps)
                        ),
                        this.state.optionData.map(function (item) {
                            return React.createElement(SelectPanelItem, {
                                key: item.id,
                                data: item,
                                active: _this2.isInValue(item),
                                onClick: _this2.onSelect
                            });
                        }),
                        this.state.optionData.length === 0 && React.createElement(
                            'div',
                            { className: 'no-data-title' },
                            '\u6682\u65E0\u5185\u5BB9'
                        )
                    ),
                    popupNodeWidth: parseFloat(realWidth),
                    popupNodeClassName: classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-multi-select-panel', true), _defineProperty(_classnames2, 'no-padding-top-bottom', showSearch), _classnames2)),
                    isShowPopup: this.state.isShowPanel,
                    onBodyClick: this.bodyClick,
                    popupNodeZIndex: zIndex,
                    preventOverflowEnabled: preventOverflowEnabled,
                    popupOnBody: popupOnBody
                }),
                tips && React.createElement(
                    'div',
                    { className: classPrefix + '-form-tips' },
                    tips
                )
            );
        }
    }]);

    return MultiSelect;
}(Component);

MultiSelect.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disabled: PropTypes.bool,
    placeHolder: PropTypes.string,
    showSearch: PropTypes.bool,
    cancelIcon: PropTypes.bool,
    getValue: PropTypes.func,
    control: PropTypes.bool,
    onSearch: PropTypes.func,
    optionData: PropTypes.array,
    value: PropTypes.array,
    name: PropTypes.string,
    label: PropTypes.node,
    tips: PropTypes.node,
    increment: PropTypes.string,
    onHandleChange: PropTypes.func,
    noWarning: PropTypes.bool,
    validate: PropTypes.object,
    zIndex: PropTypes.number,
    preventOverflowEnabled: PropTypes.bool,
    popupOnBody: PropTypes.bool,
    responsive: PropTypes.bool,
    searchClear: PropTypes.bool
};
MultiSelect.defaultProps = {
    classPrefix: classPrefix,
    width: 120,
    placeHolder: '请选择',
    optionData: [],
    value: [],
    preventOverflowEnabled: true,
    searchClear: true
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.resizeHandler = function () {
        var width = getComputedStyle(_this3.tsContainer).width;
        _this3.setState({ inputWidth: parseFloat(width) });
    };

    this.bodyClick = function () {
        _this3.setState({
            isShowPanel: false,
            inputFocus: false,
            searchValue: ''
        }, _this3.isShowPanelOnChange);
    };

    this.inputOnClick = function () {
        if (_this3.props.disabled) {
            return;
        }
        _this3.setState({
            isShowPanel: !_this3.state.isShowPanel,
            inputFocus: true,
            searchValue: ''
        }, _this3.isShowPanelOnChange);
    };

    this.iconOnClick = function (e) {
        if (_this3.props.disabled) {
            return;
        }
        var hasCancelIcon = _this3.props.cancelIcon && _this3.state.iconOnHover && _this3.props.value.length !== 0;
        if (hasCancelIcon) {
            _this3.onSelectchange([]);
        } else {
            var input = e.target.parentNode.querySelector('.multi-select-input');
            input.focus();
            _this3.setState({ isShowPanel: !_this3.state.isShowPanel }, _this3.isShowPanelOnChange);
        }
    };

    this.iconOnHover = function (e) {
        if (_this3.props.disabled) {
            return;
        }
        if (e.type === 'mouseenter') {
            _this3.setState({ iconOnHover: true });
        } else if (e.type === 'mouseleave') {
            _this3.setState({ iconOnHover: false });
        }
    };

    this.searchChange = function (e) {
        var _props3 = _this3.props,
            onSearch = _props3.onSearch,
            optionData = _props3.optionData;

        var newOptionData = optionData;
        if (e.value) {
            newOptionData = _this3.filterOptionData(e.value, optionData);
        }
        _this3.setState({
            optionData: newOptionData,
            searchValue: e.value
        }, function () {
            _.isFunction(onSearch) && onSearch(e);
        });
    };

    this.filterOptionData = function (value, data) {
        return data.filter(function (item) {
            return item.label.indexOf(value) !== -1;
        });
    };

    this.isShowPanelOnChange = function () {
        var _props4 = _this3.props,
            optionData = _props4.optionData,
            showSearch = _props4.showSearch;


        _this3.setState({
            optionData: optionData
        });

        if (_this3.state.isShowPanel && showSearch) {
            _this3.searchInputFocus(); // 自动获得焦点
        }

        if (_this3.state.isShowPanel) {
            _this3.PopperWrap.update(); // 每次点开下来就重新计算下拉位置
        }
    };

    this.onSelectchange = function (value) {
        var _props5 = _this3.props,
            getValue = _props5.getValue,
            name = _props5.name;

        _.isFunction(getValue) && getValue({
            name: name,
            value: value
        });
    };

    this.renderMultiItems = function () {
        var _props6 = _this3.props,
            value = _props6.value,
            placeHolder = _props6.placeHolder;

        if (value.length === 0) {
            return React.createElement(
                'div',
                { className: 'input-placehoder' },
                placeHolder
            );
        } else {
            return value.map(function (item) {
                return React.createElement(MultiSelectInputItem, {
                    itemObj: { title: item.label },
                    key: item.id,
                    cancelOnClick: function cancelOnClick() {
                        return _this3.cancelOnClick(item);
                    }
                });
            });
        }
    };

    this.cancelOnClick = function (_ref) {
        var id = _ref.id;

        if (_this3.props.disabled) {
            return;
        }
        var newValue = _this3.props.value.filter(function (item) {
            return item.id !== id;
        });
        _this3.onSelectchange(newValue);
    };

    this.onSelect = function (item) {
        var value = _this3.props.value;
        if (_this3.isInValue(item)) {
            value = value.filter(function (i) {
                return i.id !== item.id;
            });
        } else {
            value = [].concat(_toConsumableArray(value), [item]);
        }
        _this3.onSelectchange(value);
    };
};

export default MultiSelect;